"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chevron = exports.FilterLabel = exports.ItemsRow = exports.Row = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Container = styled_components_1.default.div `
  width: 100%;
  margin-top: ${props => props.theme.spacing.s4}px;
  padding-bottom: ${props => props.theme.spacing.s4}px;
  ${props => !props.isLast &&
    `
    border-bottom: 1px solid ${props.theme.palette.DARK_GRAY_20};
  `}
`;
exports.Row = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-right: ${props => props.theme.spacing.s1}px;
  cursor: pointer;
`;
exports.ItemsRow = styled_components_1.default.div `
  display: flex;
  position: relative;
  flex-direction: column;
  gap: ${props => props.theme.spacing.s2}px;
  justify-content: flex-start;
  margin-top: ${props => props.theme.spacing.s4}px;
  min-height: ${props => props.theme.constants.blockWidth.s27}px;
  max-height: ${props => props.theme.constants.filter.maxHeight}px;
  overflow-y: auto;
  ${props => (props === null || props === void 0 ? void 0 : props.isRange) && `padding-top: 3px;`}

  ::-webkit-scrollbar {
    width: ${props => props.theme.constants.filter.scrollBarWidth}px;
  }
  ::-webkit-scrollbar-track {
    background: ${props => props.theme.palette.LIGHT_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.palette.MEDIUM_GRAY};
    border-radius: ${props => props.theme.spacing.s1}px;
  }
  -webkit-overflow-scrolling: touch;
`;
exports.FilterLabel = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.medium};
  text-transform: capitalize;
  cursor: pointer;
  color: ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.Chevron = (0, styled_components_1.default)(svg_components_1.ChevronMediumIcon) `
  transform: ${props => (props.isOpen ? 'rotate(90deg)' : 'rotate(-90deg)')};
  cursor: pointer;
`;
exports.default = {
    Container: exports.Container,
    Row: exports.Row,
    ItemsRow: exports.ItemsRow,
    FilterLabel: exports.FilterLabel,
    Chevron: exports.Chevron
};
